<template>
  <tr>
    <td class="grey--text text--darken-2 text-xs-center">
      <b>
        {{ item.Datum | moment("DD.MM.YYYY.") }}
      </b>
    </td>
    <td class="text-xs-center">
      <b class="grey--text text--darken-2">
        {{item.TerminOd | moment("HH:mm")}} - {{item.TerminDo | moment("HH:mm")}}
      </b>
    </td>
    <td class="grey--text text--darken-2 text-xs-left">
      {{item.Ime}}
    </td>
    <td class="grey--text text--darken-2">
      {{item.UcionicaUlica}}, {{item.UcionicaGrad}}
    </td>
    <td class="grey--text text--darken-2">
      {{item.UcionicaNaziv}}
    </td>
    <td class="text-xs-center">
      <v-btn small color="red" @click="odjaviIspit()" v-if="!rokOdjaveIstekao()">
        <v-icon class="white--text"> edit</v-icon>
        <span class="white--text"> &nbsp;&nbsp;&nbsp; {{ $t('exam_unregister.terms_table.btn_unregister_exam') }} </span>
      </v-btn>

      <v-btn flat @click="startExam" target="_self" v-if="pokretanjeIspitaVidljivo()">
        <span class="red--text"> &nbsp;&nbsp;&nbsp; {{ $t('exam_unregister.exam_start') }} </span>
      </v-btn>
      <v-btn flat @click="prikaziPorukuGreske" v-if="examDataValidationError && rokOdjaveIstekao()">
        <span class="red--text"> &nbsp;&nbsp;&nbsp; {{ $t('exam_unregister.exam_start') }} </span>
      </v-btn>
    </td>
  </tr>
</template>


<script>
  import moment from 'moment';
  import { mapState } from 'vuex';

  export default {
    name: 'ExamTR',
    props: {
      item: {},
      index: ''
    },
    computed: {
      ...mapState('app', ['currentUser'])
    },
    data() {
      return {
        validationObject: {},
        greskaPrijaveIspita: '',
        examDataValidationError: false
      }
    },
    methods: {
      rowEvent() {

      },
      odjaviIspit() {
        this.$emit('examRowClick', { index: this.index, item: this.item });

      },

      rokOdjaveIstekao() {
        var datum = new Date(this.item.Datum);
        var terminOd = new Date(this.item.TerminOd);

        var danaPrije = 2; // Koliko dana ranije mora biti ispit prijavljen
        var currentDatePlus48h = new Date();
        currentDatePlus48h.setDate(currentDatePlus48h.getDate() + danaPrije);

        var prvi = moment(currentDatePlus48h);
        var drugi = new Date(datum.getFullYear(), datum.getMonth(), datum.getDate(), terminOd.getHours(), terminOd.getMinutes(), 0);
        drugi = moment(drugi);

        var razlika = drugi.diff(prvi);

        // Prema gornjoj logici, 0 je točno u vrijeme ispita, pa onda ako je manje od 0, ne može više prijaviti
        return razlika < 0;
      },

      startExam() {
        try {
          var data = {
            PredbiljezbaId: this.item.OsobaPredbiljezbe_ID,
            RasporedDatumId: this.item.RasporedDatumi_ID
          };

          this.$fetchDataPromise('/api/Exam/UpdateIzlazakNaIspit', data)
          var link = this.generateMyQTestLink();
          window.open(link, '_blank');
        } catch (error) { }
      },

      generateMyQTestLink() {
        var datumPocetkaPo = this.item.DatumPocetkaPo.split('T')[0];
        var datumVrijemePocetkaIspita = this.item.PocetakZaIspit.replace('T', ' ');
        var oib = this.currentUser.OIB.trim();

        this.validationObject = { oib: oib, ime: this.currentUser.Name, prezime: this.currentUser.Surname, podtip: this.item.PodtipNaziv, podruznicaId: this.item.Podruznica_ID, datumPocetkaPo: datumPocetkaPo, datumVrijemeIspita: datumVrijemePocetkaIspita, osobaPredbiljezbeId: this.item.OsobaPredbiljezbe_ID, rasporedDatumiId: this.item.RasporedDatumi_ID };
        var mainLink = "https://myqtest.algebra.hr/api/polaznickiPortal.aspx?";

        if (this.item.ClanKomisije1_ID == null || this.item.ClanKomisije2_ID == null || this.item.ClanKomisije3_ID == null) {
          throw new Error("Nisu postavljeni svi članovi komisije za ovaj ispit!");
        }

        var queryString = `${mainLink}ime=${this.currentUser.Name}&prezime=${this.currentUser.Surname}&oib=${oib}&poNaziv=${this.item.PodtipNaziv}&podruznicaId=${this.item.Podruznica_ID}&datumPocetkaPo=${datumPocetkaPo}&datumPolaganjaIspita=${datumVrijemePocetkaIspita}&OsobaPredbiljezbe_ID=${this.item.OsobaPredbiljezbe_ID}&RasporedDatumi_ID=${this.item.RasporedDatumi_ID}&clanKomisije1Id=${this.item.ClanKomisije1_ID}&clanKomisije1Ime=${this.item.ClanKomisije1_Ime}&clanKomisije1Prezime=${this.item.ClanKomisije1_Prezime}&clanKomisije1Email=${this.item.ClanKomisije1_Email}&clanKomisije1Oib=${this.item.ClanKomisije1_OIB}&clanKomisije2Id=${this.item.ClanKomisije2_ID}&clanKomisije2Ime=${this.item.ClanKomisije2_Ime}&clanKomisije2Prezime=${this.item.ClanKomisije2_Prezime}&clanKomisije2Email=${this.item.ClanKomisije2_Email}&clanKomisije2Oib=${this.item.ClanKomisije2_OIB}&clanKomisije3Id=${this.item.ClanKomisije3_ID}&clanKomisije3Ime=${this.item.ClanKomisije3_Ime}&clanKomisije3Prezime=${this.item.ClanKomisije3_Prezime}&clanKomisije3Email=${this.item.ClanKomisije3_Email}`;

        return queryString;
      },

      // Moguće ako je na dan ispita, i to samo do kraja ispita.
      pokretanjeIspitaVidljivo() {
        var datumPocetakIspita = new Date(this.item.Datum.split('T')[0] + ' ' + this.item.TerminOd.split('T')[1]);
        var datumKrajIspita = new Date(this.item.Datum.split('T')[0] + ' ' + this.item.TerminDo.split('T')[1]);

        if (new Date().getTime() >= datumPocetakIspita.getTime() && new Date().getTime() < datumKrajIspita.getTime()) {
          return true;
        } else {
          return false
        }
      },

    },
  }
</script>

<style scoped>
  td {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/Exams/exam_unregister_components/ExamTR.vue